import React, { useState, useRef, useEffect } from 'react'
import Calendar from 'react-calendar'
import { useDispatch, useSelector } from 'react-redux'
import { SlCalender } from "react-icons/sl";
import { IoTimeOutline } from "react-icons/io5";
// import { Elements, useStripe, useElements, CardElement } from '@stripe/react-stripe-js'
import defaultCoach from '../../../assets/images/default-coach.png'
import { BASE_URL } from '../../../keys'
import {
    useBookSlotMutation,
    useCancelBookedSlotMutation,
    useCancelRelationMutation,
    useGetTimeSlotsMutation,
} from '../../../services/coachApi'
import { useGetCurrentUserQuery } from '../../../services/authApi'
import { useGetPriceQuery } from '../../../services/currencyApi';
import { slotActions } from '../../../services/slotSlice'
import CloseButton from '../../../UI/CloseButton'
import { ToastContainer, toast } from 'react-toastify'
import BookingError from './Popups/BookingError'
import { bookingActions } from '../../../services/bookingSlice'
import Feedback from './Popups/Feedback'
import { useNavigate ,useLocation} from 'react-router-dom'
import loader from '../../../assets/images/loader.gif'
import { useGetCategoriesQuery } from '../../../services/categoryApi';
import { therapistActions } from '../../../services/therapistSlice'
// import moment from 'moment'
import moment from 'moment-timezone';
import Backdrop from '../../../UI/Backdrop'
import { Button } from 'antd';
import emptyavatar from '../../../assets/images/emptyavatar.webp'
import { useRescheduleMutation } from '../../../services/bookingApi';
import { Alert } from "antd";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ExclamationCircleOutlined, CheckCircleOutlined, CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
const currentTime = moment(new Date(), 'h:mm:ss A').format('HH:mm')
const currentDate = moment(new Date()).format('YYYY-MM-DD')

const Modal = (props) => {
    // console.log(props);
   
   const [timeSlot, setTimeSlot] = useState('')
   const [showModal, setShowModal] = useState(true); // Controls overall 
    const [amount, setAmount] = useState('')
    const [currency, setCurrency] = useState('')
  const [reschedulebooking] = useRescheduleMutation();
  const location = useLocation();
const [payNow,setPayNow]=useState(false)
const [bookNow,setBookNow]=useState(true)
    const [message, setMessage] = useState('')
    const [errorBooking, setErrorBooking] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [feedback, setFeedback] = useState(false)
     const [loadingToCancel, setLoadingToCancel] = useState(false);
      const [rescheduleLoading, setRescheduleLoading] = useState(false);
      const [showRescheduleConfirm, setShowRescheduleConfirm] = useState(false);
       const [feedbackcoachId,setFeedbackCoachId]=useState();
            const [feedbackBookId,setFeedbackBookId]=useState();
     const dispatch = useDispatch()
     const bookedSlots = useSelector((state) => state.slotReducers.booking)
    const leaveSlots = useSelector((state) => state.slotReducers.leaves)
const bookingId = useSelector((state) => state.bookingReducer.bookingId)
    const coachId = useSelector((state) => state.bookingReducer.coachId)
    const isReschedule=localStorage.getItem('rescheduleclick')
    // console.log(isReschedule);
    
    const reschedule=useSelector((state)=>state.therapistReducer.btnClick) || isReschedule
    // console.log(reschedule);
    
//    useEffect(()=>{
// dispatch(therapistActions.setBtnClick('no'))
//    },[])
    // console.log(reschedule);
    // const reschedule_bookingId=useSelector((state)=>state.therapistReducer.bookingId)
    // console.log(reschedule_bookingId);
   const reschedule_bookingdetails=useSelector((state)=>state.therapistReducer.bookingDetailsReschedule)
    // console.log(reschedule_bookingdetails);
    
// const elements = useElements();
    const [value, setValue] = useState(new Date())
  //  console.log(coachId);
   
    const { data, isSuccess, isLoading, isError } = useGetCategoriesQuery()
      //  console.log('Categories', data?.data)
    const [bookSlot, { isLoading: slotBookingLoading }] = useBookSlotMutation()
     const [cancelBookedSlot] =
        useCancelBookedSlotMutation()
    const [
        getTimeSlots,
        { isLoading: slotsLoading, isError: getSlotsError, error },
    ] = useGetTimeSlotsMutation()
    const [cancelRelation, { isLoading: cancelLoading }] =
        useCancelRelationMutation()

    const { data: userDetails } = useGetCurrentUserQuery({})
   const categoryId=localStorage.getItem("categoryid")
    const storedCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
   
    
const currencyId = storedCurrency?.id;
   const { data:getPriceData } = useGetPriceQuery({ categoryId, currencyId });
  
    const slots = useSelector((state) => state.slotReducers.slots)
  
    const navigate = useNavigate()


useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  document.body.appendChild(script);
}, []);

useEffect(() => {
 
  
  if (getPriceData?.price && getPriceData.price.amount) {
    setAmount(getPriceData?.price.amount);
    setCurrency((storedCurrency.code || 'AED').toUpperCase());
  } else {
    // Fallback: find category from allCategory by categoryId
    const categories = data?.data || [];
    const category = categories.find(cat => cat.id === Number(props.categoryId));
    
    
    if (category && category.price && category.price.amount) {
       
        
      setAmount(getPriceData.price.amount);
      setCurrency((storedCurrency.code || 'AED').toUpperCase());
    } else {
      // If still not found, fallback to defaults or ''
      setAmount('');
      setCurrency('AED');
    }
  }
}, [props.price, props.categoryId, data]);
    function formatDate() {
        var d = value,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day
 return [year, month, day].join('-')
        // return [day,month,year].join('/')
    }
    // console.log(formatDate(), 'value')

  const formatDateForDisplay = (dateStr) => {    return moment(dateStr).format('dddd, MMMM DD, YYYY');  };
  const handleRescheduleConfirm = () => {    
      
    setShowRescheduleConfirm(true);  
    };

    useEffect(() => {
      //  console.log(props?.price?.currency_code);
       
        setAmount(getPriceData?.price?.amount);
        setCurrency((storedCurrency.code || 'AED').toUpperCase());
    }, [getPriceData?.price?.amount, props?.price?.currency_code]);
// console.log(amount);
// console.log(storedCurrency.code);

    const bookYourSlot = async () => {
        const formData = new FormData()
        formData.append('date', formatDate())
        formData.append('coach_id', props.coachId)
        formData.append('category_id', props.categoryId)
        formData.append('time_slot', timeSlot)
        formData.append('amount', amount)
        formData.append('currency', storedCurrency.code)
       
        // console.log('FormData Values:')
        // for (let pair of formData.entries()) {
        //     // console.log(`${pair[0]}: ${pair[1]}`)
        // }

        try {
            const response = await bookSlot(formData)
            

            if (response?.data?.code === 'Success') {
             
            //   razorpay
const { RZP_order_id, data: bookingId } = response.data;

      const options = {
        key:"rzp_live_RcR0Eyfy5CToJ5",
        // key: "rzp_test_nlYlH13408kYk6", // test Razorpay key
        amount: parseInt(getPriceData?.price?.amount) * 100, 
        currency: storedCurrency.code,
        name: "hapsmiths",
        description: "Slot Booking",
       
        order_id: RZP_order_id,
        handler: function (response) {
          // console.log("Payment Success:", response);

         if(response){
          toast.success('Payment Successful! Redirecting...');
          setTimeout(() => {
            navigate(`/chat/${props.coachId}`);
          }, 2000);}else{
             toast.error('Payment failed try again');
            setPayNow(true)
          }
        },
        prefill: {
          name: userDetails?.data?.name || '',
          email: userDetails?.data?.email || '',
        },
        theme: {
          color: "#F77F11",
        },
         "modal": {
        "ondismiss": function () {
            setPayNow(true)
            toast.error("Payment Failed")
           
        }
    }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
            setPayNow(false)    
            }
            // console.log(response);
            
if(response?.error?.data?.data?.date){
  setErrorMessage(response?.error?.data?.data?.date[0])
}
            if (response.error.originalStatus === 500) {
                setErrorBooking(true)
                setErrorMessage('Something went wrong! Please try again.')
            } else {
                setErrorBooking(true)
                 setPayNow(false)
                if (
                    response.error.data.data.error[0] ===
                    'Please give previous session a rating.'
                ) {
                    setErrorMessage(response.error.data.error_msgs[0]) 
                    const coachIdFromError = response?.error?.data?.data_key?.[0]?.[1];
 const coachBookingId=response?.error?.data?.data_key?.[0]?.[0];
//  console.log(coachIdFromError,coachBookingId);
 setFeedbackCoachId(coachIdFromError)
 setFeedbackBookId(coachBookingId)
                   
                } else {
                    setErrorMessage(response.error.data.data.error[0])
                }
            }
if(response?.data?.constant_key==="booking_already_done"){
    
    
setErrorBooking(true)

}
           
            if (response.error.data.data.error[0]) {
                
                setPayNow(false)
                setErrorBooking(true)
                dispatch(
                    bookingActions.bookingError({
                        bookingId: response.error.data.data_key[0][0],
                        coachId: response.error.data.data_key[0][1],
                    })
                )
            }
          
           
        } catch (error) {
            

           
            
        }
    }

    const handleReschedule = async () => {
      setRescheduleLoading(true);
      localStorage.setItem('rescheduleclick','no')
  const formData = new FormData();

  formData.append("booking_id", reschedule_bookingdetails?.booking_id);
  formData.append("category_id", reschedule_bookingdetails?.booking_category_id);
  formData.append("date", formatDate());
  formData.append("time_slot", timeSlot);
  formData.append("coach_id", reschedule_bookingdetails?.booking_coach_id);

  try {
    const result = await reschedulebooking(formData).unwrap();
    // console.log("Reschedule Success:", result);
    if(result){
         toast.success('Booking rescheduled successfully');
         setShowRescheduleConfirm(false);
          setTimeout(() => {
            navigate(`/chat/${reschedule_bookingdetails?.booking_coach_id}`);
          }, 2000);
         
          dispatch(therapistActions.setBtnClick('no'))
          dispatch(therapistActions.setBookingDetailsReschedule())
          
        }else{
             toast.error('Reschedule failed try again');
            dispatch(therapistActions.setBtnClick('no'))
            dispatch(therapistActions.setBookingDetailsReschedule())
          }
   
  } catch (err) {
    // console.log("Reschedule Failed:", err);
    toast.error(err?.data?.data?. booking_id[0])
    
            dispatch(therapistActions.setBookingDetailsReschedule())
            setTimeout(() => {
            navigate(`/chat/${reschedule_bookingdetails?.booking_coach_id}`);
          }, 2000);
          dispatch(therapistActions.setBtnClick('no'))
  }
};


    
const cancelBookedSlotHandler = async () => {
   
  const formData = new FormData();
  formData.append('booking_id', parseInt(bookingId));
  formData.append('coach_id', parseInt(coachId));
  formData.append('category_id', props.categoryId);

  try {
    const response = await cancelBookedSlot(formData);
   
    
    if (response?.data?.code === 'Success') {
      toast.success('Booking Cancelled Successfully!Now Try new Booking');

     
      setErrorBooking(false); 
           
setPayNow(true)
      return response; // return to let pauseRelationHandler re-book
    } else {
      toast.error('Cancel failed');
      return response;
    }

  } catch (err) {
    
    toast.error('Cancel booking failed');
    return { error: err };
  }
};
   
    const pauseRelationHandler = async () => {
       
        const formData = new FormData()

        formData.append('date', formatDate())
        formData.append('coach_id', props.coachId)
        formData.append('category_id', props.categoryId)
        formData.append('time_slot', timeSlot)
        formData.append('pause_relation', 'yes')
        formData.append('amount', amount)
        formData.append('currency', currency)
        try {
            const response = await cancelRelation(formData)
            //eslint-disable-next-line
            
           
             if (response?.data?.code === 'Success') {
            //   razorpay
const { RZP_order_id, data: bookingId } = response.data;

      const options = {
         key:"rzp_live_RcR0Eyfy5CToJ5",
        // key: "rzp_test_nlYlH13408kYk6", // test Razorpay key
        amount: parseInt(amount) * 100, 
        currency: storedCurrency.code,
        name: "hapsmiths",
        description: "Slot Booking",
        // image: "/your-logo.png", // optional
        order_id: RZP_order_id,
        handler: function (response) {
          // console.log("Payment Success:", response);

         
          toast.success('Payment Successful! Redirecting...');
          setTimeout(() => {
            navigate(`/chat/${props.coachId}`);
          }, 2000);
        },
        prefill: {
          name: userDetails?.data?.name || '',
          email: userDetails?.data?.email || '',
        },
        theme: {
          color: "#F77F11",
        },
         "modal": {
        "ondismiss": function () {
            setPayNow(true);
           
        }
    }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
            // setPayNow(false)    
            }
if(response?.data?.constant_key==="booking_already_done"){
   const cancelresponse=await cancelBookedSlotHandler();
  //  console.log(cancelresponse);
 if(cancelresponse?.data?.code==='Success'){
   
   
    
return;
}

}
  
           
            setErrorBooking(false)
            // toast.success(
            //     'Paused previous relationship!Now try new Booking'
            // )
           
           

            if (response.error.data.data.error[0]) {
                dispatch(
                    bookingActions.bookingError({
                        bookingId: response.error.data.data_key[0][0],
                        coachId: response.error.data.data_key[0][1],
                    })
                )
            }
            // setErrorBooking(false)
        } catch (error) {
            // console.log(error)
        }
    }


    const mainRef = useRef(null)

const handleClick = async () => {
  const formData = new FormData();
  formData.append('date', formatDate());
  formData.append('coach_id', props.coachId);
  formData.append('category_id', props.categoryId);

  try {
    const response = await getTimeSlots(formData);
    // console.log('API response:', response);

    // Handle error or no slots case early
    if (
      response?.data?.code !== 'Success' ||
      response?.error?.data?.error_key === 'all_slots'
    ) {
      // Clear Redux slot states to prevent stale slots showing
      dispatch(slotActions.getSlots([]));
      dispatch(slotActions.getBookedSlots([]));
      dispatch(slotActions.getLeaveSlots([]));

      setMessage('Try changing date.');
      return; // Stop further processing
    }

    // Safely access data
    const data = response?.data?.data;

    if (!data?.slots || !Array.isArray(data.slots) || data.slots.length === 0) {
      // No slots found
      dispatch(slotActions.getSlots([]));
      dispatch(slotActions.getBookedSlots([]));
      dispatch(slotActions.getLeaveSlots([]));

      // setMessage('No slots found! Try changing date.');
      return;
    }

    // Convert slot times from UTC to user timezone or local
     const deviceTimezone = localStorage.getItem('device_timezone')
    const userTimezone = userDetails?.data?.timezone?.name || deviceTimezone;
    // console.log(userTimezone,deviceTimezone);
    
    const slotTimes = data.slots.map((s) => {
      const utcDateTime = moment.utc(`${s.session_date} ${s.slot}`, 'YYYY-MM-DD HH:mm');

      const localMoment = userTimezone
        ? utcDateTime.clone().tz(userTimezone)
        : utcDateTime.local();

      return {
        time: localMoment.format('HH:mm'),
        available: s.is_slot_available,
      };
    });


    // Update Redux state with fetched slots and related info
    dispatch(slotActions.getSlots(slotTimes));
    dispatch(slotActions.getBookedSlots(data.booking || []));
    dispatch(slotActions.getLeaveSlots(data.leaves || []));

    // Clear message since slots are available
    setMessage('');
  } catch (error) {
    // On network or unexpected error, clear slots and show message
    dispatch(slotActions.getSlots([]));
    dispatch(slotActions.getBookedSlots([]));
    dispatch(slotActions.getLeaveSlots([]));
    // setMessage('No slots found! Try changing date.');
    
  }
};


    useEffect(() => {
        handleClick()
        //eslint-disable-next-line
    }, [value])

const deviceTimezone = localStorage.getItem("device_timezone");

    let previousLocalDate = null;
let previousLocalTime = null;

if (reschedule_bookingdetails) {
  previousLocalDate = moment
    .utc(reschedule_bookingdetails.booking_session_date)
    .tz(deviceTimezone)
    .format("YYYY-MM-DD");
//  console.log(previousLocalDate);

  previousLocalTime = moment
    .utc(
      `${reschedule_bookingdetails.booking_session_date} ${reschedule_bookingdetails.booking_session_time}`,
      "YYYY-MM-DD HH:mm"
    )
    .tz(deviceTimezone)
    .format("HH:mm");
}
// console.log(previousLocalTime);

// Check if currently viewed calendar date is the previously booked date
const isPreviousDate =
  moment(value).format("YYYY-MM-DD") === previousLocalDate;
  // console.log(isPreviousDate);
   
    const formatTo12Hour = (time24) => {
  return moment(time24, "HH:mm").format("hh:mm A");
};

const RescheduleConfirmationModal = () => { 
     if (!showRescheduleConfirm) return null;    
     return (    
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50"> 
               <div className="bg-white rounded-2xl w-[90%] max-w-md mx-4 overflow-hidden shadow-2xl animate-fadeIn"> 
 {/* Header */}        
   <div className="bg-orange px-6 py-4"> 
              <h3 className="text-white text-lg font-bold text-center">  
    Confirm Reschedule           
    </h3>         
  </div>   
    {/* Body */} 
   <div className="p-6"> 
{/* Warning Message */}   
   <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6"> 
 <div className="flex items-start gap-3">
 <ExclamationCircleOutlined className="text-amber-500 text-xl mt-0.5" /> 
  <div>  
   <p className="text-amber-800 font-semibold text-xs"> Important Reminder </p>  
   <p className="text-amber-700 text-xs mt-1"> You can only reschedule this appointment <strong>once</strong>. Please verify the details below before confirming.</p>
   </div>
  </div>  </div>
    {/* Current Booking Info */} 
   <div className="mb-4"> 
   <p className="text-gray-500 text-xs uppercase tracking-wide mb-2">Current Appointment</p>
    <div className="bg-red-50 border border-red-100 rounded-lg p-3">  
   <div className="flex items-center gap-2 text-red-600">
     <CalendarOutlined /> <span className="text-sm line-through">{formatDateForDisplay(previousLocalDate)}</span> </div>
     <div className="flex items-center gap-2 text-red-600 mt-1"> 
   <ClockCircleOutlined />  
   <span className="text-sm line-through">{formatTo12Hour(previousLocalTime)}</span> </div>  </div>
    </div>
  {/* Arrow */} 
  <div className="flex justify-center my-3"> 
  <div className="bg-gray-200 rounded-full p-2"> <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor"  viewBox="0 0 24 24">   
   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3"/></svg></div>            
   </div>           
    {/* New Booking Info */}  
   <div className="mb-6"> 
   <p className="text-gray-500 text-xs uppercase tracking-wide mb-2">New Appointment </p> 
   <div className="bg-green-50 border border-green-200 rounded-lg p-3">                
   <div className="flex items-center gap-2 text-green-700">                  
   <CalendarOutlined />                 
    <span className="text-sm font-semibold">                    
    {formatDateForDisplay(formatDate())}</span>                
    </div>                
    <div className="flex items-center gap-2 text-green-700 mt-1"><ClockCircleOutlined />                 
     <span className="text-sm font-semibold">{formatTo12Hour(timeSlot)}</span>               
      </div> </div></div>            
      {/* Confirmation Question */}           
       <div className="text-center mb-6"> 
        <p className="text-gray-700 font-medium">Are you sure you want to reschedule to this new time? </p> </div> 
                   {/* Action Buttons */}           
      <div className="flex gap-3">             
     <button onClick={() => {setShowRescheduleConfirm(false);localStorage.setItem('rescheduleclick','no')}} disabled={rescheduleLoading} 
  className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15">Cancel </button>
             <button onClick={handleReschedule} disabled={rescheduleLoading}  className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15">                
              {rescheduleLoading ? (
                <>Processing... </>) : (<>
  Confirm Reschedule</>)}</button></div></div></div></div>    
  );  
};
    return (
        <>
          {(errorBooking || feedback || bookNow) && <Backdrop />}

           <div className="fixed z-[999] w-screen h-screen top-0 left-0 flex justify-center items-center bg-[#4040407c] findTherapistCalModal">
                <ToastContainer hideProgressBar />
 <RescheduleConfirmationModal />
                {errorBooking && (
                    <BookingError
                        cancelBookedSlotHandler={cancelBookedSlotHandler}
                        loadingToCancel={loadingToCancel}
                        onClickYes={pauseRelationHandler}
                        cancelLoading={cancelLoading}
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                        onClickNo={() => {setErrorBooking(false); 
                          navigate(0);
                          // navigate(`/chat/${props.coachId}`)
                          //  navigate(location.pathname, { replace: true });
                        }}
                        message={errorMessage}
                    />
                     
                )}

                {/* {feedback && (
                    <Feedback
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                        closeModal={() => {
                          props.closeModal();
    setFeedback(false);
    setErrorBooking(false);
   
  }}
                    />
                )} */}

                {bookNow && !errorBooking && !feedback && (
                    <div className="w-5/12 md:w-9/12 xs:w-full sm:w-full bg-white rounded-2xl overflow-hidden">
                        <div
                            onClick={handleClick}
                            ref={mainRef}
                            className="h-10 w-full pt-2 mb-3 relative bg-[#FDE9D8] text-center font-bold"
                        >
                            Book Your Appointment
                            {props.btnClick === 'no' && (
                                <CloseButton
                                    onClick={props.closeModal}
                                    className="absolute top-2 right-10 cursor-pointer text-gray-500"
                                />
                            )}
                            {props.btnClick === 'yes' && (
                                <CloseButton
                                    onClick={() =>
                                      {  navigate(`/chat/${props.coachId}`); dispatch(therapistActions.setBtnClick('no'));localStorage.setItem("rescheduleclick",'no')}

                                    }
                                    className="absolute top-2 right-10 cursor-pointer text-gray-500"
                                />
                            )}
                        </div>
{reschedule==='yes' &&<Alert
  message={
    <div className="text-orange-800 text-sm">
      <strong>Important:</strong> You can only reschedule this appointment once.
      Please choose carefully.
    </div>
  }
  type="warning"
  showIcon
  icon={<ExclamationCircleOutlined className="text-orange-600" />}
  className="mx-6 bg-orange-50 border-orange-200 mb-2"
/>}
{reschedule==='no'&&<Alert
  message={
    <div className="text-orange-800 text-xs">
      <strong>No Refund Policy:</strong> Bookings made less than 24 hours in advance are non-refundable. 
      <br />
      <strong>Cancellation Policy:</strong> Cancel up to 24 hours before your appointment for free. 
    </div>
  }
  type="warning"
  showIcon
  icon={<ExclamationCircleOutlined className="text-orange-600" />}
  className="mx-6 bg-orange-50 border-orange-200 mb-2"
/>}
                        <Calendar
                            onChange={(e) => setValue(e)}
                            defaultValue={new Date()}
                            minDate={new Date()}
                            maxDate={
                                new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
                            }
                            className="mx-auto"
                            value={value}
                           tileClassName={({ date, view }) => {
                            // console.log(view,date);
                            
    if (view === "month") {
      const calendarDate = moment(date).format("YYYY-MM-DD");

      if (reschedule==='yes' && (calendarDate === previousLocalDate)) {
       
        
        return "highlight-previous-date";
      }
    }
    return null;
  }}
                        />
<div className='flex items-center justify-center py-1 text-gray-400'>Hey there! You're on {localStorage.getItem('device_timezone')} timezone</div>
                      
<div
  id="slotContainer"
  className="flex flex-wrap justify-center gap-2 my-3 w-full px-10 max-h-[90px] overflow-y-auto"
>
  {error?.data?.error_key === 'all_slots' && (
    <p>All slots are booked for this date.</p>
  )}

  {!error?.data?.error_key && getSlotsError && (
    <p className="text-center w-full">
      An error occurred! Please try changing date or coach.
    </p>
  )}

  {!slotsLoading ? (
    Array.isArray(slots) && slots.length > 0 ? (
      <>
        {slots.map((item, index) => {
          const slotTime = moment(item.time, 'HH:mm');
          const current = moment(currentTime, 'HH:mm');

          const isToday =
            moment(currentDate).format('YYYY-MM-DD') ===
            moment(value).format('YYYY-MM-DD');

          const isPast = isToday && current.isAfter(slotTime);
          const isBooked = (bookedSlots || []).includes(item.time);
          const isLeave = (leaveSlots || []).includes(item.time);
          const isUnavailable = item.available === 0;
// console.log(item.time);
const slotDateTime = moment(
  moment(value).format("YYYY-MM-DD") + " " + item.time,
  "YYYY-MM-DD HH:mm"
);

const sixHourBuffer = moment().add(6, "hours");

// Disable only if booking & slot is within 6 hours
const isWithin6Hours = slotDateTime.isBefore(sixHourBuffer);
          const isDisabled = isPast || isBooked || isLeave || isUnavailable || isWithin6Hours;
const isPreviouslySelected =
  previousLocalDate === moment(value).format("YYYY-MM-DD") &&
  previousLocalTime === item.time;
  // console.log(isPreviouslySelected);
  // console.log(previousLocalTime === item.time);
  
  //   console.log(previousLocalDate === moment(value).format("YYYY-MM-DD"));
    
          // 🩶 Disabled (past/booked/leave/unavailable)
          if (isDisabled && !isPreviouslySelected) {
            return (
              <div
                key={index}
                className="p-1 flex justify-center items-center text-sm w-20 rounded-[40px] border-gray border-2 text-center text-gray-500 cursor-no-drop opacity-50"
              >
                {/* <div className="w-2 h-2 rounded-full bg-gray-300 mr-2"></div> */}
                {formatTo12Hour(item.time)}
              </div>
            );
          }
          if (reschedule==='yes' && isPreviouslySelected) {
  return (
    <div
      key={index}
      className="p-1 flex items-center justify-center text-sm w-20 rounded-[40px] border-green-500 border-2 bg-lightblue text-gray-700 opacity-100"
    >
      {/* <div className="w-2 h-2 rounded-full bg-green-700 mr-2"></div> */}
      {formatTo12Hour(item.time)}
    </div>
  );
}


            
          // 🟠 Available (clickable)
          return (
            <div
              key={index}
              onClick={() => setTimeSlot(item.time)}
              className={
                'active:bg-orange p-1 flex text-sm justify-center items-center w-20 cursor-pointer rounded-[40px] border-[#FFC289] border-2 text-center ' +
                (timeSlot === item.time
                  ? ' bg-orange text-white'
                  : ' text-gray-500')
              }
              
            >
              {/* <div className="w-2 h-2 rounded-full bg-heavyBorder mr-2"></div> */}
             
              {formatTo12Hour(item.time)}
            </div>
          );
        })}
      </>
    ) : (
      <div>{message || 'No slots found!'}</div>
    )
  ) : (
    'Loading...'
  )}
</div>





                        <div className="flex  items-center flex-col justify-center py-3 w-full gap-4">
                           
                            <button
                            onClick={()=>{
                              // console.log("click");
                              
                              if(reschedule==='yes')
                                { 
                                  // console.log("fgcgv");
                                  handleRescheduleConfirm();
                                  // handleReschedule(); 

                                }
                                else{
                                setPayNow(true); setBookNow(false)}}}
                                // onClick={bookYourSlot}
                                // disabled={slotBookingLoading}
                                disabled={timeSlot ? false : true}
                                className=" w-36 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15"
                            >
                                {slotBookingLoading ? (
                                    <img
                                        src={loader}
                                        className="w-8 h-8 mx-auto"
                                        alt=""
                                    />
                                ) : (
                                    'Confirm'
                                )}
                            </button>
                        </div>
                    </div>
                )}
                {payNow &&
                <div className="w-5/12 md:w-9/12 xs:w-full sm:w-full bg-white rounded-2xl overflow-hidden">
                <div className="h-10 w-full pt-2 mb-3 relative bg-[#FDE9D8] text-center font-bold"><span>Confirm Payment</span><button className='absolute right-3' onClick={()=>{setPayNow(false);setBookNow(true)}}>x</button></div>
               
                     <div className="flex items-start gap-8 pt-8 px-4">
        {/* <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-300"> */}
          <img className='w-[55px] h-[55px] rounded-full object-cover' alt="image"
        src= {props?.coachImage ? `${BASE_URL}${props?.coachImage}` : emptyavatar} 
       onError={(e) => {
    e.currentTarget.src = emptyavatar;
  }} />

       
        {/* </div> */}

        <div className="flex-1">
          <div className="text-lg font-semibold ">{props?.coachName} 
            </div>
        
          <div className="flex items-center text-sm  mt-3 space-x-4 gap-7">
            <div className="flex items-center gap-1">
              <span className="material-icons text-base"><SlCalender /></span>
              <span>{formatDate()}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="material-icons text-base"><IoTimeOutline /></span>
              <span>{formatTo12Hour(timeSlot)}</span>
            </div>
          </div>
          
<div className='p-1 mt-2 font-semibold'>
  {props?.sessionduration.replace(/_/g, '-')} consultation with your coach
</div>
          <div className="text-xl text-lightOrange font-semibold mt-4">
             {storedCurrency?.symbol} {getPriceData?.price?.amount}
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-6 gap-4 px-4 pb-10">
        <button className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15"onClick={()=>{setPayNow(false);setBookNow(true)}}>
          Cancel
        </button>
        <button className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15" onClick={bookYourSlot}>
          Pay Now
        </button>
       
      </div>
                    </div>
                    }
            </div>
             {feedback && (
                    <Feedback
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                        feedbackcoachId={feedbackcoachId}
          feedbackBookId={feedbackBookId}
                         closeModal={() => {
                          props.closeModal();
    setFeedback(false);
    setErrorBooking(false);
   
  }}
                    />
                )}
        </>
    )
}

export default Modal

